<div class="modal-header ks-confirm__header">
  <span
    class="ks-confirm__icon"
    [class.ks-confirm__icon--danger]="isDanger()"
    [class.ks-confirm__icon--warning]="isWarning()"
    aria-hidden="true">
    <i class="bi bi-{{ icon() }}"></i>
  </span>

  <h2 class="modal-title" id="ks-confirm-title">{{ title() }}</h2>

  <button
    type="button"
    class="ks-modal-close"
    aria-label="Cerrar dialogo"
    (click)="cancel()">
    <i class="bi bi-x-lg" aria-hidden="true"></i>
  </button>
</div>

<div class="modal-body">
  <p class="ks-confirm__message">{{ message() }}</p>

  @if (detail()) {
    <p class="ks-confirm__detail">{{ detail() }}</p>
  }
</div>

<div class="modal-footer">
  <button type="button" class="ks-btn ks-btn--glass" (click)="cancel()">
    {{ cancelLabel() }}
  </button>

  <button
    type="button"
    class="ks-btn"
    [class.ks-btn--red]="isDanger()"
    [class.ks-btn--warning]="isWarning()"
    [class.ks-btn--primary]="!isDanger() && !isWarning()"
    (click)="confirm()">
    {{ confirmLabel() }}
  </button>
</div>
